// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";
// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## Bank Account Get All
/**
 *
 * @param {{params: object, query: { parasutAccountId?: string }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.BankAccount.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};

// ## Bank Account Create
/**
 *
 * @param {{ name: string, currency: string, parasutInfo: object|null, mikroInfo: object|null }} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.BankAccount.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Bank Account Update
/**
 *
 * @param {{ name: string, currency: string, parasutInfo: object|null, mikroInfo: object|null, isActive: boolean }} form
 * @param {{params: { id: string }, query: object}} option
 *
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.BankAccount.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Bank Account Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 *
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.BankAccount.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Bank Account Details
/**
 *
 * @param {{params: object, query: {page: number, limit: number, parasutAccountId?: string}}} option
 *
 * @returns
 */
export const BankAccountDetails = async (option) => {
  const response = await $api.get(
    Endpoints.BankAccount.BankAccountDetails(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};

// ## Mikro Bank Accounts
/**
 *
 * @param {{params: object, query: { mikroAccountId?: string }}} option
 *
 * @returns
 */
export const MikroBankAccounts = async (option) => {
  const response = await $api.get(
    Endpoints.BankAccount.MikroBankAccounts(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};

// ## Mikro Bank Account Details
/**
 *
 * @param {{params: object, query: {page: number, limit: number, mikroAccountId?: string}}} option
 *
 * @returns
 */
export const MikroBankAccountDetails = async (option) => {
  const response = await $api.get(
    Endpoints.BankAccount.MikroBankAccountDetails(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};

export default {
  GetAll,
  Create,
  Update,
  Delete,
  BankAccountDetails,
  MikroBankAccounts,
  MikroBankAccountDetails,
};
